import styled, { css } from 'styled-components';
import { readableColor, lighten } from 'polished';

const isColor = (color) => {
  const colorRegExp = new RegExp(
    '/^(rgb|hsl)a?((d+%?(deg|rad|grad|turn)?[,s]+){2,3}[s/]*[d.]+%?)$/i',
  );
  if (color.charAt(0) === '#') {
    color = color.substring(1);
    return [3, 4, 6, 8].indexOf(color.length) > -1 && !isNaN(parseInt(color, 16));
  } else if (colorRegExp.test(color)) {
    return colorRegExp.test(color);
  }

  const s = new Option().style;
  s.color = color;
  return s.color === color;
};

export const TableRow = styled.tr`
  ${({
    selectable, hideCheckbox, inMobile, expand,
  }) => {
    if ((selectable && hideCheckbox) || (selectable && inMobile)) {
      return css`
        cursor: pointer;
      `;
    }

    if (expand && inMobile) {
      return css`
        cursor: pointer;
      `;
    }

    return css`
      cursor: auto;
    `;
  }};

  border-bottom: thin solid transparent;
  ${({ even, theme, selected }) => {
    if (selected) {
      return css`
        color: ${readableColor(theme.primaryColor)};
        background-color: ${lighten(0.1, theme.primaryColor) || '#24405B'};
        border-bottom: thin solid ${readableColor(theme.primaryColor)};
      `;
    } else if (even) {
      return css`
        background-color: ${theme.evenTableRow};
      `;
    }

    return css`
      background-color: ${theme.formBackground};
    `;
  }}

  box-sizing: border-box;
  display: table-row !important;
  height: 100%;

  ${(props) => {
    if (props.borderColor) {
      if (isColor(props.borderColor)) {
        return css`
          border-bottom: thin solid ${props.borderColor};
        `;
      }
      return css`
        border-bottom: ${props.borderColor};
      `;
    }
  }}

  &&&& {
    ${({ conditionalRowStyle }) => conditionalRowStyle};
  }
`;
